import type { ReactNode } from 'react';

const TONE_CLASS = {
  neutral: 'badge-neutral',
  success: 'badge-success',
  danger: 'badge-danger',
  warning: 'badge-warning',
};

/**
 * A pill. `neutral` for tags, `success`/`danger` for a status, `warning` for
 * something missing that the user should fill in.
 */
export function Badge({
  tone,
  children,
}: {
  tone: keyof typeof TONE_CLASS;
  children: ReactNode;
}) {
  return <span className={TONE_CLASS[tone]}>{children}</span>;
}

/** Badges that wrap onto as many lines as they need. */
export function BadgeList({ children }: { children: ReactNode }) {
  return <div className="badge-list">{children}</div>;
}
